import React, { useState, useEffect } from "react";
import { makeStyles, TextField, CircularProgress } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Pagination } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import Moment from "moment";
import { getBotWeekly, getBotWeeklyResult, findLoginId } from "../modules/api";
import { Line } from "react-chartjs-2";

export function BotWeekly() {
	const useStyles = makeStyles((theme) => ({
		container: {
			display: "flex",
			flexWrap: "wrap",
		},
		textField: {
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			width: 200,
		},
		centeredHeader: {
			"& span": {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				fontSize: 15,
				fontWeight: "bold",
			},
		},
	}));
	const classes = useStyles();

	// The first commit of Material-UI
	const [listLoading, setListLoading] = useState(false);
	const [botWeeklyList, setBotWeeklyList] = useState([]);
	const [botAdminList, setBotAdminList] = useState([]);
	const [botAdminId, setBotAdminId] = useState();
	const [startDate, setStartDate] = useState(
		Moment()
			.add(-7, "days")
			.format("YYYY-MM-DD")
	);
	const [endDate, setEndDate] = useState(
		Moment(new Date()).format("YYYY-MM-DD")
	);
	const [weeklyDateList, setWeeklyDateList] = useState([]);
	const [weeklyTotalCnt, setWeeklyTotalCnt] = useState([]);
	const [weeklySuccCnt, setWeeklySuccCnt] = useState([]);
	const [weeklyFailCnt, setWeeklyFailCnt] = useState([]);

	const fetchData = async (value) => {
		try {
			const role = localStorage.getItem("userRole");
			if (role === "SystemAdmin") {
				const botAdminList = await findLoginId();
				console.log("botAdminList", botAdminList);
				setBotAdminList(botAdminList.data);
			}
			console.log(startDate, endDate, value);
			const result = await getBotWeekly(startDate, endDate, value);
			const res = await getBotWeeklyResult(startDate, endDate, value);

			console.log("getBotWeekly", result);
			console.log("getBotWeeklyResult", res);

			let list = [];
			result.data.map((data, index) => {
				let type;
				if (data.execType === "1") {
					type = "레시피";
				} else if (data.execType === "2") {
					type = "북";
				} else {
					type = "예약";
				}
				var obj = new Object();
				obj.idx = index;
				obj.no = data.no;
				obj.botId = data.bot.loginId;
				obj.botExeDate =
					Moment(data.startExecDt).format("HH:mm:ss") +
					"~" +
					Moment(data.endExecDt).format("HH:mm:ss");
				obj.botExeName = data.execNm;
				obj.botExeResult = data.successYn;
				obj.botExeType = type;
				obj.botExeStartDate = Moment(data.startExecDt).format(
					"YYYY-MM-DD HH:mm:ss"
				);
				list.push(obj);
			});
			setBotWeeklyList(list);

			let weeklyDateList = [];
			let weeklySuccCnt = [];
			let weeklyTotalCnt = [];
			let weeklyFailCnt = [];
			res.weeklyExeCount.map((data, index) => {
				weeklyDateList.push(data.execDate.substring(5, 10));
				weeklyTotalCnt.push(data.execCnt);
				weeklySuccCnt.push(data.successCnt);
				weeklyFailCnt.push(data.failCnt);
			});
			setWeeklyDateList(weeklyDateList);
			setWeeklyTotalCnt(weeklyTotalCnt);
			setWeeklySuccCnt(weeklySuccCnt);
			setWeeklyFailCnt(weeklyFailCnt);
		} catch (e) {
			console.log(e);
			// Handle error
		}
	};

	useEffect(() => {
		setListLoading(true);
		setTimeout(async () => {
			fetchData();
			setListLoading(false);
		}, 1000);
	}, []);

	const handleStartDateChange = (e) => {
		// console.log("e", e.target.value);
		setStartDate(e.target.value);
	};
	const handleEndDateChange = (e) => {
		// console.log("e", e.target.value);
		setEndDate(e.target.value);
		// fetchData();
	};

	const columns = [
		{
			name: "botId",
			label: "Bot ID",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "botExeResult",
			label: "실행 결과",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
				customBodyRender: (value, meta) => {
					let color;
					let text;
					if (value === "Y") {
						color = "label-success";
						text = "성공";
					} else {
						color = "label-primary";
						text = "실패";
					}
					return (
						<span className={"label label-xl label-inline " + color}>
							{text}
						</span>
					);
				},
			},
		},
		{
			name: "botExeName",
			label: "실행 작업명",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "botExeType",
			label: "실행 타입",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "botExeDate",
			label: "실행 시간",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "botExeStartDate",
			label: "실행 일시",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
	];

	const options = {
		print: false,
		// download: false,
		filter: false,
		viewColumns: false,
		rowsPerPage: 15,
		rowsPerPageOptions: [],
		selectableRows: "none",
		textLabels: {
			body: {
				noMatch: listLoading ? (
					<CircularProgress size={25} color={"inherit"} />
				) : botWeeklyList.length > 0 ? (
					""
				) : (
					"검색 결과가 없습니다."
				),
			},
		},
	};

	return (
		<div id="pageid30">
			<div
				className="d-flex align-items-center justify-content-between w-100"
				style={{ marginTop: 30, marginBottom: 50 }}
			>
				<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
					기간 별 전체 실행 결과 현황
				</h3>
				{localStorage.getItem("userRole") === "SystemAdmin" && (
					<div className="fv-plugins-icon-container mr-5">
						<select
							className="form-control form-control-lg form-control-solid"
							style={{ borderColor: "black", width: "200px" }}
							name="botAdminList"
							onChange={(e) => {
								fetchData(e.target.value);
								setBotAdminId(e.target.value);
							}}
						>
							<option value="">선택</option>
							{botAdminList &&
								botAdminList.length > 0 &&
								botAdminList.map((data, index) => {
									return <option value={data.no}>{data.loginId}</option>;
								})}
						</select>
					</div>
				)}
			</div>
			<div className="top-row gutter-b d-flex justify-content-end align-items-center">
				<form className={classes.container} noValidate>
					<TextField
						id="date"
						type="date"
						defaultValue={startDate}
						className={classes.textField}
						onChange={(e) => handleStartDateChange(e)}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</form>
				<span> ~ </span>
				<form className={classes.container} noValidate>
					<TextField
						id="date"
						type="date"
						defaultValue={endDate}
						className={classes.textField}
						onChange={(e) => handleEndDateChange(e)}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</form>
				<Button
					onClick={() => fetchData(botAdminId)}
					style={{ marginLeft: "10px" }}
					className={`btn btn-info font-weight-bold text-white`}
				>
					검색
				</Button>
			</div>
			<div
				className="gutter-b graph"
				style={{ backgroundColor: "rgb(255,255,255)" }}
			>
				<Line
					options={{
						responsive: true,
						scales: {
							y: {
								min: 0,
								ticks: {
									stepSize: 1
								}
							}
						},
						maintainAspectRatio: false,
						plugins: {
							legend: {
								position: "bottom",
							},
						},
					}}
					data={{
						labels: weeklyDateList,
						datasets: [
							{
								label: "전체",
								data: weeklyTotalCnt,
								fill: false,
								backgroundColor: "rgb(192,192,192)",
								borderColor: "rgb(192,192,192)",
								tension: 0.5,
							},
							{
								label: "성공",
								data: weeklySuccCnt,
								fill: false,
								backgroundColor: "rgb(90, 181, 2)",
								borderColor: "rgb(90, 181, 2)",
								tension: 0.5,
							},
							{
								label: "실패",
								data: weeklyFailCnt,
								fill: false,
								backgroundColor: "#ff6f5e",
								borderColor: "#ff6f5e",
								tension: 0.5,
							},
						],
					}}
					height={200}
					width={350}
				/>
			</div>
			<div className="gutter-b table">
				{/* <div className="gutter-b d-flex align-items-center justify-content-between w-100">
					<b></b>
					<Button className={`btn btn-light-dark font-weight-bold text-white`}>
						엑셀 다운로드
					</Button>
				</div> */}
				<div className="table-responsive">
					<MUIDataTable
						// title={"Bot 관리"}
						data={botWeeklyList}
						columns={columns}
						options={options}
					/>
					{/* <table
						className="table table-head-custom table-vertical-center bg-white"
						id="kt_advance_table_widget_1"
					>
						<thead>
							<tr className="text-left">
								<th style={{ width: "150px" }}>Bot ID</th>
								<th style={{ width: "150px" }}>실행일</th>
								<th style={{ minWidth: "100px" }}>전체 실행건수</th>
								<th style={{ minWidth: "100px" }}>실행 성공건수</th>
								<th style={{ minWidth: "100px" }}>실행 실패건수</th>
								<th style={{ minWidth: "100px" }}>실행률</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
							<tr>
								<td>Logan1</td>
								<td>2021-05-13</td>
								<td>100</td>
								<td>50</td>
								<td>50</td>
								<td>20%</td>
							</tr>
						</tbody>
					</table> */}
				</div>
			</div>
			{/* <div className="row">
				<div className="d-flex flex-center w-100">
					<Pagination>
						<Pagination.Prev />

						<Pagination.Item>{1}</Pagination.Item>
						<Pagination.Item>{2}</Pagination.Item>
						<Pagination.Item active>{3}</Pagination.Item>
						<Pagination.Item disabled>{4}</Pagination.Item>
						<Pagination.Item>{5}</Pagination.Item>

						<Pagination.Next />
					</Pagination>
				</div>
			</div> */}
		</div>
	);
}

export default BotWeekly;
